import { createUseStyles } from 'react-jss';
import { colors } from '../../constants/colors';

const styles = createUseStyles((theme) => ({
  escalation: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  leaveContainer: {
    maxWidth:"380px",
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    height: '100%',
    margin: "24px auto",
    padding: "0px 10px"
  },
  title: {
    textAlign: "center",
    fontSize: '30px',
    fontWeight: '600',
    lineHeight: '38px',
    color: colors.lightBlack,
    marginBottom: '12px',
  },
  description: {
    textAlign: "center",
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    color: colors.mediumGrey,
    marginBottom: '12px',
  },
  lang: {
    display: "flex",
    alignItems: "center",
    alignSelf: "end",
    margin: "32px 64px",
    height: "32px",
    "& :focus:not(.focus-visible)":{
      outline:0,
    },
    "& :focus-visible":{
      boxShadow: "0px 0px 0px 4px " + colors.lightBlue
    },
    "&:hover": {
      cursor: "pointer",
      textColor: theme.navigation.li.active.color,
    },
    "& .langSelector": {
      display: "flex",
      width: "100%",
      textDecoration: "none",
      color: colors.grey,
      borderRadius: "4px",
      "& div": {
        marginLeft: "14px",
        alignSelf: "center",
      },
    },
  },
  locale: {
    textTransform: "uppercase",
    "&:hover": {
      color: theme.navigation.li.active.color,
    },
  },
  popoverStyle:{
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverImage:{
    marginRight:"10px"
  },
  overlayLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: colors.grey,
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    padding: "10px",
    marginLeft:"24px",
    "&:hover": {
      color: colors.grey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px"
    },
    width: "100%",
  },
}));

export default styles;
